export enum UserStatus {
  ACTIVE = 'ACTIVE',
  ACTIVE_TASK = 'ACTIVE_TASK',
  AWAY = 'AWAY',
  IDLE = 'IDLE',
  OFFLINE = 'OFFLINE',
  OUT_OF_OFFICE = 'OUT_OF_OFFICE',
}
